import {atom} from 'recoil';

export const ownDeclaration = atom({
  key: 'ownDeclaration',
  default: [],
});
